<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div>
            <FormInput :label="$t('formularios.dni')" name="dni" rules="required" v-model="base.dni" />
        </div>
        
        <div v-if="error" class="alert alert-danger" role="alert">
            {{ error }}
        </div>
        <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_base.renovar') }}</span></button>
    </ValidationObserver>
</template>

<script>
export default {
    props: ['base', 'error'],
    data() {
        return {
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        teatro(){
            return this.$store.getters.getTeatro;
        },
    },
    methods: {
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.terminar();
            }
        },
        terminar() {
            this.$emit('terminado');
        }
    },
}
</script>
